import React from 'react';
import cx from 'classnames';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Icon } from 'js/components';
import { faWeightHanging } from '@fortawesome/pro-regular-svg-icons';
import { TooltipWithBounds } from '@visx/tooltip';
import {
  formatScore,
  formatWeightFraction,
  scoreIcon,
  scoreIconColor,
} from './rubricTreemapUtils';
import styles from './RubricTreemap.module.scss';

export default function QuestionTooltip({
  tooltipOpen,
  tooltipData,
  tooltipLeft,
  tooltipTop,
}) {
  if (!tooltipOpen || !tooltipData) {
    return null;
  }

  return (
    <TooltipWithBounds
      left={tooltipLeft}
      top={tooltipTop}
      className={styles['tooltip']}
    >
      <div className={styles['tooltip-title']}>
        {tooltipData.type === 'question_set' ? 'Question Set' : 'Question'}
      </div>
      <div className={styles['tooltip-label']}>
        {tooltipData.label || tooltipData.text || 'Question'}
      </div>
      <div className={styles['tooltip-row']}>
        <div>
          <Icon
            icon={scoreIcon(tooltipData.score)}
            className={cx('icon icon-left', styles['tooltip-icon'])}
            style={{ color: scoreIconColor(tooltipData.score) }}
            fixedWidth
          />
          {formatScore(tooltipData.score)}
        </div>
        <div>
          <Icon
            icon={faWeightHanging}
            className={cx('icon icon-left', styles['tooltip-icon'])}
            fixedWidth
          />
          {tooltipData.type === 'question_set'
            ? formatWeightFraction(
                tooltipData.weight,
                tooltipData.totalRubricWeight
              )
            : formatWeightFraction(
                tooltipData.areaWeight,
                tooltipData.totalSetWeight
              )}
        </div>
      </div>
    </TooltipWithBounds>
  );
}
